
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-you/following",
      function () {
        return require("private-next-pages/for-you/following.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-you/following"])
      });
    }
  